import React from "react";
import { Routes, Route } from "react-router-dom";

import { SignIn } from "../pages/SignIn/Index";
import { Users } from "../pages/Painel/components/Users";
import { ContractCanceled } from "../pages/Painel/components/ContractCanceled";
import { ContractCanceledInfo } from "../pages/Painel/components/ContractCanceledInfo";
import { UserInfo } from "../pages/Painel/components/UserInfo";

import PrivateRoutes from "./PrivateRoutes";
const MainRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<SignIn />} />

    <Route path="/" element={<PrivateRoutes />}>
      <Route path="/users" element={<Users />} />
      <Route path="/contractCanceled" element={<ContractCanceled />} />
      <Route
        path="/contractCanceled/:contract_id/info"
        element={<ContractCanceledInfo />}
      />
      <Route path="/users/:profile_id/profile" element={<UserInfo />} />
    </Route>

    <Route path="*" element={<p> Not found </p>} />
  </Routes>
);

export default MainRoutes;
